import { render } from "./OtpModel.vue?vue&type=template&id=3d690cdf"
import script from "./OtpModel.vue?vue&type=script&lang=js"
export * from "./OtpModel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__